var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithoutQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05337 5.7645C6.27537 5.7645 6.46887 5.7375 6.63387 5.6835C6.79887 5.6265 6.93537 5.547 7.04337 5.445C7.15437 5.34 7.23687 5.214 7.29087 5.067C7.34487 4.917 7.37187 4.7505 7.37187 4.5675C7.37187 4.3935 7.34487 4.236 7.29087 4.095C7.23687 3.954 7.15587 3.834 7.04787 3.735C6.93987 3.636 6.80337 3.561 6.63837 3.51C6.47337 3.456 6.27837 3.429 6.05337 3.429H5.14887V5.7645H6.05337ZM6.05337 2.493C6.48837 2.493 6.86487 2.544 7.18287 2.646C7.50087 2.748 7.76337 2.8905 7.97037 3.0735C8.17737 3.2565 8.33037 3.4755 8.42937 3.7305C8.53137 3.9855 8.58237 4.2645 8.58237 4.5675C8.58237 4.8825 8.52987 5.172 8.42487 5.436C8.31987 5.697 8.16237 5.922 7.95237 6.111C7.74237 6.3 7.47837 6.447 7.16037 6.552C6.84537 6.657 6.47637 6.7095 6.05337 6.7095H5.14887V9H3.93837V2.493H6.05337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithoutQuotation);
export default __webpack_public_path__ + "static/media/withoutQuotation.8da455a565c2a8b3a605e5dc63868970.svg";
export { ForwardRef as ReactComponent };